export default __webpack_public_path__ + "static/media/finished_cherry_product.8f00adb7.jpg";